import { useState } from "react";

import useService from "../../../../hooks/useService";
import { getModalHandler } from "../../Common/Modals/hooks/useModalSingleton";
import { useSettlementStore } from "../store/settlementStore";

export default function useOtherLiensBalanceDeleteModal({
  expenseData,
  handleCloseModal,
  onDeleteSuccess,
}) {
  const additionalExpenseRepository = useService("repositories/additional-expense-repository");
  const { openFailureModal, openSuccessModal } = getModalHandler();
  const bumpRefreshVersion = useSettlementStore((state) => state.bumpRefreshVersion);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    if (!expenseData) {
      return;
    }

    try {
      setIsDeleting(true);
      const expenseId = expenseData?.pk || expenseData?.id;
      await additionalExpenseRepository.delete(expenseId);
      await onDeleteSuccess?.();
      bumpRefreshVersion();
      openSuccessModal();
      handleCloseModal();
    } catch (error) {
      openFailureModal(error);
    } finally {
      setIsDeleting(false);
    }
  };

  return {
    isDeleting,
    handleDelete,
  };
}
